module.exports = __webpack_public_path__ + "img/weizhangjiaofei.a70108a1.png";